(() => {
  document.documentElement.classList.add('js');

  const liveRegion = document.querySelector('[data-live-region]');
  const announce = (message) => {
    if (!liveRegion) return;
    liveRegion.textContent = '';
    window.setTimeout(() => { liveRegion.textContent = message; }, 20);
  };

  const header = document.querySelector('[data-site-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(open));
      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.hidden = !open;
    });
  }

  const searchPanel = document.querySelector('[data-search-panel]');
  const searchTriggers = document.querySelectorAll('[data-search-open]');
  const searchClose = searchPanel?.querySelector('[data-search-close]');
  const setSearch = (open) => {
    if (!searchPanel) return;
    searchPanel.classList.toggle('is-open', open);
    searchPanel.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) window.setTimeout(() => searchPanel.querySelector('input')?.focus(), 40);
  };
  searchTriggers.forEach((trigger) => trigger.addEventListener('click', () => setSearch(true)));
  searchClose?.addEventListener('click', () => setSearch(false));
  searchPanel?.addEventListener('click', (event) => { if (event.target === searchPanel) setSearch(false); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setSearch(false); });

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-product-filter-group]').forEach((group) => {
    const buttons = group.querySelectorAll('[data-product-filter]');
    const targetId = group.getAttribute('data-target');
    const grid = document.getElementById(targetId);
    if (!grid) return;
    const cards = grid.querySelectorAll('[data-product-card]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      const filter = (button.dataset.productFilter || 'all').toLowerCase();
      buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      cards.forEach((card) => {
        const matches = filter === 'all' || (card.dataset.filterText || '').includes(filter);
        card.hidden = !matches;
      });
      announce(`Showing ${filter === 'all' ? 'all products' : filter}`);
    }));
  });

  document.querySelectorAll('[data-fit-finder]').forEach((finder) => {
    const form = finder.querySelector('form');
    const result = finder.querySelector('[data-fit-result]');
    if (!form || !result) return;
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const selected = Array.from(new FormData(form).values());
      if (selected.length < Number(form.dataset.questionCount || 3)) {
        announce('Choose one answer for each fit question.');
        return;
      }
      const scores = selected.reduce((acc, fit) => {
        acc[fit] = (acc[fit] || 0) + 1;
        return acc;
      }, {});
      const winner = Object.entries(scores).sort((a, b) => b[1] - a[1])[0]?.[0] || 'relaxed';
      const source = finder.querySelector(`[data-fit-copy="${winner}"]`);
      result.querySelector('[data-fit-number]').textContent = source?.dataset.number || '01';
      result.querySelector('[data-fit-name]').textContent = source?.dataset.name || 'Relaxed';
      result.querySelector('[data-fit-description]').textContent = source?.dataset.description || '';
      const link = result.querySelector('[data-fit-link]');
      if (link && source?.dataset.url) link.href = source.dataset.url;
      result.classList.add('is-visible');
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      announce(`Your recommended fit is ${source?.dataset.name || winner}.`);
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  const formatMoney = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return (format || '£{{amount}}').replace(/\{\{\s*amount(?:_with_comma_separator)?\s*\}\}/, amount);
  };

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = root.querySelector('[data-product-json]');
    const inventoryJson = root.querySelector('[data-variant-inventory-json]');
    const form = root.querySelector('[data-product-form]');
    if (!json || !form) return;
    let product;
    let variantInventory = [];
    try { product = JSON.parse(json.textContent); } catch (_) { return; }
    try { variantInventory = inventoryJson ? JSON.parse(inventoryJson.textContent) : []; } catch (_) { variantInventory = []; }
    const variantInput = form.querySelector('[name="id"]');
    const button = form.querySelector('[name="add"]');
    const buttonLabel = button?.querySelector('[data-add-label]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-compare-price]');
    const saleBadge = root.querySelector('[data-sale-badge]');
    const deliveryEta = root.querySelector('[data-delivery-eta]');
    const deliveryHeading = deliveryEta?.querySelector('[data-delivery-heading]');
    const deliveryCopy = deliveryEta?.querySelector('[data-delivery-copy]');
    const moneyFormat = root.dataset.moneyFormat;

    const updateDeliveryEta = (variant) => {
      if (!deliveryEta || !deliveryHeading || !deliveryCopy) return;
      const inventory = variantInventory.find((item) => String(item.id) === String(variant.id));

      if (inventory?.inventory_management && Number(inventory.inventory_quantity) > 0) {
        deliveryEta.dataset.deliveryState = 'in-stock';
        deliveryHeading.textContent = 'In stock – ready to dispatch';
        deliveryCopy.textContent = 'Dispatched within 1–2 working days via Royal Mail Tracked 48.';
        return;
      }

      if (inventory?.inventory_policy === 'continue') {
        deliveryEta.dataset.deliveryState = 'made-to-order';
        deliveryHeading.textContent = 'Made to order';
        deliveryCopy.textContent = 'Produced especially for you and delivered within 28 days.';
        return;
      }

      if (variant.available) {
        deliveryEta.dataset.deliveryState = 'available';
        deliveryHeading.textContent = 'Available';
        deliveryCopy.textContent = 'Delivery timing will be confirmed at checkout.';
        return;
      }

      deliveryEta.dataset.deliveryState = 'out-of-stock';
      deliveryHeading.textContent = 'Out of stock';
      deliveryCopy.textContent = 'This option is currently unavailable.';
    };

    const selectedOptions = () => Array.from(root.querySelectorAll('[data-option-position]')).reduce((values, input) => {
      if (input.checked) values[Number(input.dataset.optionPosition) - 1] = input.value;
      return values;
    }, []);

    const updateVariant = () => {
      const values = selectedOptions();
      const variant = product.variants.find((item) => item.options.every((option, index) => option === values[index]));
      if (!variant) {
        if (button) button.disabled = true;
        if (buttonLabel) buttonLabel.textContent = 'Unavailable';
        if (deliveryEta && deliveryHeading && deliveryCopy) {
          deliveryEta.dataset.deliveryState = 'out-of-stock';
          deliveryHeading.textContent = 'Unavailable';
          deliveryCopy.textContent = 'Choose another option to see delivery information.';
        }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, moneyFormat);
      if (compare) {
        compare.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price, moneyFormat) : '';
        compare.hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
      }
      if (saleBadge) saleBadge.hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
      updateDeliveryEta(variant);
      if (button) button.disabled = !variant.available;
      if (buttonLabel) buttonLabel.textContent = variant.available ? buttonLabel.dataset.availableLabel : buttonLabel.dataset.soldLabel;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      const media = root.querySelector(`[data-media-id="${variant.featured_media?.id}"]`);
      media?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    root.querySelectorAll('[data-option-position]').forEach((input) => input.addEventListener('change', updateVariant));
    updateVariant();
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
      const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityStep || 0));
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  });
})();
